const progress = (seconds, duration) => 1 - Math.pow(1 - Math.max(0, Math.min(1, seconds / duration)), 3);

export function componentMotionStyle(preset, frame, fps = 30) {
  const seconds = frame / fps;
  const active = preset !== 'none';
  return {
    opacity: active ? progress(seconds, 0.5) : 1,
    translate: `${preset === 'slide-left' ? 24 * (1 - progress(seconds, 0.7)) : 0}px ${preset === 'soft-float' ? 16 * (1 - progress(seconds, 0.8)) : 0}px`,
    scale: String(preset === 'zoom-in' ? 1 + 0.04 * (1 - progress(seconds, 0.8)) : 1),
  };
}

// Legacy presets retain their entrance-only behavior. New settings compose three stages.
export function stagedMotionStyle(value, frame, fps = 30, durationInFrames = 90, inline = false) {
  if (typeof value === 'string') return componentMotionStyle(inline && value !== 'none' ? 'fade' : value, frame, fps);
  const stages = value || {};
  const entry = inline && stages.in !== 'none' ? 'fade' : stages.in || 'none';
  const exit = inline && stages.out !== 'none' ? 'fade' : stages.out || 'none';
  const duration = Math.max(0, (durationInFrames - 1) / fps);
  const entryDuration = entry === 'none' ? 0 : Math.min(entry === 'fade' ? .5 : entry === 'slide-left' ? .7 : .8, duration / 2);
  const exitDuration = exit === 'none' ? 0 : Math.min(exit === 'fade' ? .5 : exit === 'slide-left' ? .7 : .8, duration / 2);
  const seconds = Math.max(0, frame / fps);
  if (entryDuration && seconds < entryDuration) return componentMotionStyle(entry, seconds / entryDuration * (entry === 'fade' ? .5 : entry === 'slide-left' ? .7 : .8) * fps, fps);
  if (exitDuration && seconds > duration - exitDuration) {
    const amount = Math.max(0, Math.min(1, (seconds - (duration - exitDuration)) / exitDuration));
    const eased = amount * amount * (3 - 2 * amount);
    return { opacity: 1 - eased, translate: `${exit === 'slide-left' ? -24 * eased : 0}px ${exit === 'soft-float' ? -16 * eased : 0}px`, scale: String(exit === 'zoom-in' ? 1 + .04 * eased : 1) };
  }
  const mainDuration = duration - entryDuration - exitDuration;
  const phase = mainDuration > 0 ? Math.max(0, Math.min(1, (seconds - entryDuration) / mainDuration)) : 0;
  const float = !inline && stages.main === 'soft-float' ? -8 * Math.pow(Math.sin(Math.PI * phase), 2) * Math.sin(2 * Math.PI * phase) : 0;
  return { opacity: 1, translate: `0px ${float}px`, scale: '1' };
}
